<!-- 进口好处 -->
<template>
  <div class=" bgBox dip">
    <div class="conBox ">
      <div class="fontBox">
        <div class="fontCon">
          <div class="conH3">{{ $fanyi("从中国，直接送到你的办公室") }}</div>
          <div class="conH2">{{ $fanyi("让与中国的贸易更便捷") }}</div>
          <div class="conCon">
            {{ $fanyi("从中国进口的所有优势，简单无忧。") }}
          </div>
        </div>
      </div>
      <div class="itemRowListBox">
        <div class="rowBox dip">
          <!-- 图片 -->
          <div class="imgBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202410/6717150aea0cf.png"
              alt=""
            />
          </div>
          <!-- 文字 -->
          <div>
            <div class="rowfontBox">
              <div class="titleH2">{{ $fanyi("找到你想要的一切") }}</div>
              <div class="titleH3">
                {{
                  $fanyi(
                    "在 Rakumart，你可以找到数百万种来自中国优质供应商的产品，质量可靠，价格有竞争力."
                  )
                }}
              </div>
              <div class="rowUl">
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span v-html="$fanyi('+100,000家已验证供应商。')"></span>
                </div>

                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span v-html="$fanyi('数百万种商品可供选择.')"></span>
                </div>
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span v-html="$fanyi('1688.com的官方合作伙伴')"></span>
                </div>
              </div>
            </div>
            <el-button
              type="primary"
              class="bgBlueBtn"
              @click="$fun.routerToPage('/Registrati')"
              >{{ $fanyi("免费注册") }}</el-button
            >
          </div>
        </div>

        <div class="rowBox dip" style="height: 545px;">
          <!-- 文字 -->
          <div>
            <div class="rowfontBox">
              <div class="titleH2">{{ $fanyi("与中国直接联系") }}</div>
              <div class="titleH3">
                {{
                  $fanyi(
                    "没有更多烦恼！我们负责从工厂到您家门口的整个物流流程。您只需专注于您的业务。"
                  )
                }}
              </div>
              <div class="rowUl">
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span
                    v-html="$fanyi('我们负责所有单证、手续与海关流程的管理。')"
                  ></span>
                </div>
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span
                    v-html="
                      $fanyi(
                        '我们在中国和意大利都有机构，让我们能在整个进口流程中掌控货物派送进展。'
                      )
                    "
                  ></span>
                </div>
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span v-html="$fanyi('全流程100%意大利语服务。')"></span>
                </div>
              </div>
            </div>
            <el-button
              type="primary"
              class="bgBlueBtn"
              @click="$fun.routerToPage('/Registrati')"
              >{{ $fanyi("免费注册") }}</el-button
            >
          </div>
          <!-- 图片 -->
          <div class="imgBox">
            <img
              style="width: 885px;"
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260616135412990615.png"
              alt=""
            />
          </div>
        </div>

        <div class="rowBox dip" v-if="false">
          <!-- 图片 -->
          <div class="imgBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202410/67171d8e74722.png"
              alt=""
            />
          </div>
          <!-- 文字 -->
          <div>
            <div class="rowfontBox" style="width: 530px;padding-right: 40px;">
              <div class="titleImg dip jstart">
                <img
                  src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202410/6717208c22ad8.png
"
                  alt=""
                />
              </div>
              <div class="titleH2">{{ $fanyi("单一平台上的全部流程") }}</div>
              <div class="titleH3">
                {{
                  $fanyi(
                    "从一个地方管理你的商品。所有在一起！无需离开我们的平台即可享受导入过程。"
                  )
                }}
              </div>
              <div class="rowUl">
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span v-html="$fanyi('实时跟踪您的货物。')"></span>
                </div>
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span
                    v-html="$fanyi('创建供应商和商品收藏夹，随时取用。')"
                  ></span>
                </div>
                <div class="rowLi">
                  <img
                    src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026051211320342278.svg"
                    alt=""
                  />
                  <span v-html="$fanyi('成为最大进口商社区的一员。')"></span>
                </div>
              </div>
            </div>
            <el-button
              type="primary"
              class="bgBlueBtn"
              @click="$fun.routerToPage('/Registrati')"
              >{{ $fanyi("免费注册") }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.bgBox {
  background: #fff;
}
.conBox {
  padding: 56px 0;
  .fontBox {
    text-align: center;
    margin: 0 auto 80px;
    .conH3 {
      color: var(--Rakumart-500, #009246);
      font-size: 20px;
      font-weight: 700;
      line-height: 30px; /* 150% */
      margin-bottom: 8px;
    }
    .conH2 {
      color: #013b2d;

      font-size: 36px;
      font-weight: 600;
      line-height: 44px; /* 122.222% */
      letter-spacing: -0.72px;
      margin-bottom: 16px;
    }
    .conCon {
      font-size: 18px;
      line-height: 28px; /* 155.556% */
    }
  }

  .itemRowListBox {
    width: 1470px;
    @extend .fdcolmun;
    gap: 112px;
    .rowBox {
      @extend .jsb;
      gap: 96px;
      .imgBox {
        img {
          //   width: 100%;
          //   height: 100%;
        }
      }

      .rowfontBox {
        display: flex;
        flex-direction: column;
        gap: 24px;
        .titleH2 {
          color: #013b2d;
          font-size: 30px;
          font-weight: 700;
          line-height: 38px; /* 126.667% */
        }
        .titleH3 {
          color: var(--Gray-700, #344054);
          font-size: 18px;
          line-height: 28px; /* 155.556% */
        }
        .rowUl {
          display: flex;
          flex-direction: column;
          gap: 20px;
          padding-left: 16px;
          .rowLi {
            display: flex;
            align-items: flex-start;
            img {
              width: 28px;
              height: 28px;
              margin-right: 12px;
            }
            span {
              font-size: 16px;
              line-height: 24px; /* 150% */
              color: #013b2d;
            }
          }
        }
      }
      .bgBlueBtn {
        margin-top: 48px;
        width: 183px;
        height: 44px;
      }
    }
  }
}
</style>
